import { z } from 'zod';
import { ownershipDetails } from '../shared';
import { ApplicantType } from '../types';

export {
  smeDirectorWithLicence,
  smeDirectorBasic,
  partnershipOwnershipDetails,
  proprietaryLimitedCompanyOwnershipDetails,
  trustOwnershipDetails,
  soleTraderOwnershipDetails,
  ownershipDetails,
} from '../shared';

export const ownershipDetailsFormSchema = z.object({
  enterprise: ownershipDetails,
  applicant: z.object({
    type: z.nativeEnum(ApplicantType),
  }),
});

export type OwnershipDetailsType = z.infer<typeof ownershipDetailsFormSchema>;
